import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "components/Loader";
import UserInvite from "components/UserInvite";
import classNames from "classnames";
import Scrollbar from "react-scrollbars-custom";
import Button from "components/CustomButton";
import ClickAwayListener from "react-click-away-listener";
import { useInvitationsContext } from "store/contexts/invitationContext";

export default ({
  isLoading,
  invitations,
  getNextInvitationPageData,
  invitationTotal,
  setInvitationTotal,
  setInvitations,
}) => {
  const { closeInviations } = useInvitationsContext();
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const LoadingContainer = (
    <>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} width={35} height={35} />
        </h4>
      )}
      {!isLoading && (
        <h4>
          <Button onClick={getNextInvitationPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <ClickAwayListener onClickAway={closeInviations}>
      <div
        className={classNames({
          "invitations-sidebar": true,
          invitationsBar: true,
          noInvitationBar: invitations.length === 0 ? true : false,
        })}
      >
        <Scrollbar>
          <InfiniteScroll
            style={{ overflow: "hidden" }}
            dataLength={invitationTotal ?? 0}
            next={getNextInvitationPageData}
            hasMore={invitations.length !== invitationTotal}
            loader={LoadingContainer}
            scrollableTarget="main-panel-right"
            endMessage={
              <div style={{ textAlign: "center" }}>
                {invitationTotal > 0 && (
                  <div>Yay! You have seen all invitations.</div>
                )}
              </div>
            }
          >
            <UserInvite
              isLoading={isLoading}
              user_invitations={invitations}
              setInvitations={setInvitations}
              setInvitationTotal={setInvitationTotal}
              invitationTotal={invitationTotal}
            />
          </InfiniteScroll>
        </Scrollbar>
      </div>
    </ClickAwayListener>
  );
};
